import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookings = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	fill: "none",
	role: "img",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentcolor",
		fillRule: "evenodd",
		d: "M6.3 7.3c0-2 1.7-3.7 3.7-3.7s3.7 1.7 3.7 3.7-1.7 3.6-3.7 3.6-3.7-1.7-3.7-3.6M10 5C8.8 5 7.8 6 7.8 7.3c0 1.1 1 2.1 2.2 2.1s2.2-1 2.2-2.1S11.2 5 10 5m3.5 9.7a4 4 0 0 0-3.5-1.9c-2.7 0-5 2.7-5 7.4H3.3c0-5 2.8-8.8 6.6-8.9q3 0 4.7 2.5t1.9 6.4H15q0-3.6-1.6-5.5M14.5 5a5.4 5.4 0 0 1 7.5 5c0 2.6-2 4.8-4.5 5.3l.1 1.5A7 7 0 1 0 14 3.5zm2.9 4.6V6.3h-1.5v4l2.5 2.5 1.1-1z",
		clipRule: "evenodd"
	})]
});
export default SvgBookings;
